/**
 * Module dependencies.
 */
var Strategy = require('./strategy');


/**
 * Expose `Strategy` directly from package.
 */
exports = module.exports = Strategy;

/**
 * Export constructors.
 */
exports.Strategy = Strategy;



//////////////////
// WEBPACK FOOTER
// ./~/passport-local/lib/index.js
// module id = 1486
// module chunks = 2